/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LuFeedbackRead } from '../models/LuFeedbackRead';
import type { LuFeedbackRequest } from '../models/LuFeedbackRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LuService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Submit Lu Feedback
     * Submit feedback for a Lu AI interaction.
     *
     * Requires authentication. Stores the full conversation exchange data
     * in S3 and creates a feedback record for tracking.
     * @param requestBody
     * @returns LuFeedbackRead Successful Response
     * @throws ApiError
     */
    public submitLuFeedback(
        requestBody: LuFeedbackRequest,
    ): CancelablePromise<LuFeedbackRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ai/lu/feedback',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
